import React from 'react';

const Overlay = (props) => {
  let { sidebarIsActive, toggleSidebar } = props;
  if (!sidebarIsActive) return null;
  return <div id='Overlay' className='overlay' onClick={toggleSidebar}></div>;
};

export default Overlay;
